package com.merkost.handpass.api.dto.listing

import com.merkost.handpass.api.dto.MonetaryAmount
import com.merkost.handpass.api.enums.Condition
import com.merkost.handpass.api.enums.ListingStatus
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ListingResponse(
    val id: String,
    @SerialName("category_id") val categoryId: String,
    @SerialName("seller_id") val sellerId: String,
    val title: String,
    val description: String? = null,
    val price: MonetaryAmount,
    val condition: Condition,
    val images: List<ListingImageDto> = emptyList(),
    val status: ListingStatus,
    @SerialName("view_count") val viewCount: Int = 0,
    @SerialName("favorite_count") val favoriteCount: Int = 0,
    val location: ListingLocationDto? = null,
    @SerialName("shipping_available") val shippingAvailable: Boolean = false,
    @SerialName("is_negotiable") val isNegotiable: Boolean = false,
    @SerialName("is_favorite") val isFavorite: Boolean = false,
    @SerialName("created_at") val createdAt: String,
    @SerialName("updated_at") val updatedAt: String? = null,
    @SerialName("published_at") val publishedAt: String? = null,
    @SerialName("expires_at") val expiresAt: String? = null,
    val slug: String = "",
    val category: CategoryResponse? = null,
    val seller: SellerInfoDto? = null,
    @SerialName("distance_km") val distanceKm: Double? = null
)
